import Splide from '@splidejs/splide';

class Slider {
  constructor(element) {
    this.blockElement = element;
    this.splideElement = this.blockElement.querySelector('.splide');
  }

  init() {
    if (!this.splideElement) {
      return;
    }

    const options = JSON.parse(
      this.splideElement.dataset.splideOptions || '{}'
    );

    // Podgląd ACF w edytorze renderuje się wielokrotnie – usuń poprzednią instancję
    if (this.splideElement.splide) {
      this.splideElement.splide.destroy();
    }

    const splide = new Splide(this.splideElement, options);

    splide.mount();
    this.splideElement.splide = splide;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.slider-block').forEach((blockElement) => {
    const instance = new Slider(blockElement);
    instance.init();
  });
});

// Gutenberg / ACF – po każdym wyrenderowaniu podglądu bloku (w edytorze WP 7+ jest w iframe)
if (typeof acf !== 'undefined') {
  acf.addAction('render_block_preview/type=slider', ($block) => {
    const root = $block[0];
    const blocks = root.matches('.slider-block')
      ? [root]
      : root.querySelectorAll('.slider-block');

    blocks.forEach((blockElement) => {
      const instance = new Slider(blockElement);
      instance.init();
    });
  });
}
